<div bsModal #modal="bs-modal" class="modal fade video-form" tabindex="-1" role="dialog" aria-hidden="false">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">{{ queryParams.modalTitle | translate }}</h4>
            </div>
            <div class="modal-body">
                <form [formGroup]="form" novalidate (ngSubmit)="submit(form.value, form.valid)">
                    <div class="row">
                        <div class="form-group col-xs-12">
                            <input formControlName="show" type="checkbox" id="show-on-support"/>
                            <label for="show-on-support">{{ 'Show Video on Support page' | translate }}</label>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xs-4 video-form--thumbnails">
                            <label for="title">{{ 'Video preview' | translate }}</label>
                            <div class="img-space" [class.loading]="isUploading">
                                <ng-container *ngIf="isVideoSaved || videoURL;">
                                    <video id="video_player" width="100%" height="240" controls controlsList="nodownload" appNoRightClick>
                                        <source [src]="videoURL" type="video/mp4">
                                        Your browser does not support the video tag.
                                    </video>
                                </ng-container>
                                <div class="img-space__icon">
                                    <i *ngIf="!isUploading" class="fas fa-play img-space--button"></i>
                                    <i *ngIf="isUploading" class="fas fa-spinner img-space--button"></i>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-xs-12 fileInputProfileWrap mr-t--sm">
                                    <input matInput id="imageUpload" type="file" (change)="fileChangeEvent($event)" class="fileInputProfile hidden" />
                                    <label for="imageUpload" class="btn btn-primary btn-upload">{{ 'Upload file' | translate }}</label>
                                    <div *ngIf="video.video && video.video_url" class="mr-t--sm">
                                        <span>{{ 'Video' | translate }} : 
                                            <a href="{{ video.video_url }}" target="_blank" rel="noopener"> {{ video.video }}</a>
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div *ngIf="imageError" class="row" role="alert">
                                <div class="col-sm-12">
                                    <div class="alert alert-danger">
                                        <i class="fas fa-exclamation-circle" aria-hidden="true"></i>
                                        {{ imageError | translate}}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xs-8 video-form--content">

                            <input type="hidden" formControlName="id">
                            <div *ngIf="successMessage" class="row form-group" role="alert">
                                <div class="col-sm-12">
                                    <div class="alert alert-info">
                                        {{ successMessage | translate }}
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="errorMessage.length > 0" class="row form-group" role="alert">
                                <div class="col-sm-10">
                                    <div class="alert alert-danger">
                                        <div *ngFor="let error of errorMessage">
                                            <i class="fas fa-exclamation-circle" aria-hidden="true"></i>
                                            {{ error | translate}}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="form-group col-xs-12">
                                    <span *ngIf="video && video['language_flag']">
                                        <img [src]="video['language_flag']">
                                    </span>
                                </div>
                            </div>
                            <div class="row">
                                <div class="form-group col-xs-12">
                                    <label for="title">{{ 'Video name' | translate }} *</label>
                                    <input type="text" class="form-control" id="title" formControlName="title">
                                    <small class="form-text text-danger" [hidden]="form.controls.title.valid ||
                                                                           (form.controls.title.pristine &&
                                                                           !formSubmitted)">
                                        {{ 'Video name is required.' | translate }}
                                    </small>
                                </div>
                            </div>
                            <div class="row">
                                <div class="form-group col-xs-12">
                                    <label for="title">{{ 'Video Description' | translate }}</label>
                                    <app-tinymce #videoDescription formControlName="description"
                                                 id="content"
                                                 [options]="
                                                            {
                                                            menubar: false,
                                                            toolbar: 'bold italic alignleft numlist bullist link formatselect | removeformat'
                                                            }"
                                    ></app-tinymce>
                                    <br>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-xs-12 text-xs-right">
                                    <button type="button" class="btn btn-secondary" (click)="hideModal()">
                                        {{ 'Cancel' | translate }}
                                    </button>
                                    <button type="submit" class="btn btn-primary" [class.disabled]="form.controls.duration.value == 0">
                                        <span>{{ 'Save' | translate }}</span>
                                    </button>
                                </div>
                            </div>

                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
